import { GENERATE_INVOICE } from '../../endpoints';
import { Bonus } from '../../types/agent';
import makeAuthenticatedRequest from '../base-api';

interface GenerateInvoiceResponse {
  success: boolean;
  message?: string;
  invoiceUrl: string;
  totalAmount: number;
  totalHours: number;
}

interface GenerateInvoicePayload {
  agentId: string;
  account: string;
  date: string;
  additionalDetails?: {
    arrears?: number;
    bonuses?: Bonus[];
  };
}

const generateInvoiceApi = async (
  payload: GenerateInvoicePayload
): Promise<GenerateInvoiceResponse> => {
  try {
    const response = await makeAuthenticatedRequest(GENERATE_INVOICE, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload),
    });

    const result = await response.json();

    if (!response.ok) {
      if (result.message) {
        throw new Error(result.message);
      } else {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
    }

    return result;
  } catch (error) {
    console.error('Generate invoice failed:', error);
    throw error;
  }
};

export {
  generateInvoiceApi,
  type GenerateInvoiceResponse,
  type GenerateInvoicePayload,
};
